@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.tagList {
  vertical-align: middle;
}

.tag {
  display: inline-flex;
  align-items: center;
  background-color: var(--tc-tag-chip-bg, #{v.$palette-accent-raw});
  border-radius: 10px;
  padding: 10px 16px;
  line-height: 0;
  margin: 4px;
}

.title {
  display: block;
  @include t.text(12px, 14px, 500);
  margin-right: 8px;
  color: var(--tc-tag-chip-color, #{v.$palette-pure-white});
}

.ico {
  cursor: pointer;
  color: var(--tc-tag-chip-color, #{v.$palette-pure-white});
}
